const initialState = {
    expandRouteMenu: false,
    isSideMenuNavigation: true,
    isAdminFetching: false,
    isNoticeAdmin: false,
    isCategoryAdmin: false,
    accessDetails: {}
}

// METHOD TO SET ADMIN FETCHING
const setAdminFetching = (state, action) => {
    return {
        ...state,
        isAdminFetching: action.adminFetching
    };
}

// METHOD TO SET NOTICE ADMIN DETAILS
const setNoticeAdminDetails = (state, action) => {
    return {
        ...state,
        isNoticeAdmin: action.payload.isNoticeAdmin,
        isCategoryAdmin: action.payload.isCategoryAdmin,
        accessDetails: action.payload.accessDetails,
    };
}

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action) => {
    switch (action.type) {
        case 'TOGGLE_ROUTE_MENU': return { ...state, expandRouteMenu: action.toggleFlag };
        case 'SET_SIDE_MENU_NAVIGATION': return { ...state, isSideMenuNavigation: action.sideMenuNavigation };
        case 'SET_ADMIN_FETCHING': return setAdminFetching(state, action);
        case 'SET_NOTICE_ADMIN_DETAILS': return setNoticeAdminDetails(state, action);
        default: return state;
    }
};